import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["value", "className"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useRef, forwardRef } from 'react';
import styled from '@xstyled/styled-components';
import { unescape } from 'lodash';
import { MathfieldElement } from 'mathlive';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledDiv = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  p {\n    margin-bottom: 16px;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  /* Styles for math elements */\n  .math-container {\n    display: inline-block;\n    vertical-align: middle;\n    min-width: 30px;\n    margin: 0 2px;\n  }\n\n  math-field {\n    font-size: 18px;\n    padding: 4px 2px;\n    border: none;\n    background: transparent;\n    --hue: 210;\n    --highlight-color: hsla(var(--hue), 97%, 85%, 0.5);\n    --font-family: 'Latin Modern Math', 'Cambria Math', math;\n    --smart-fence: true;\n    --smart-superscript: true;\n    font-kerning: normal;\n    text-rendering: optimizeLegibility;\n    --math-mode-space: 1em;\n    letter-spacing: 0.5px;\n  }\n"])));
export var MathEnabledTextComponent = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var value = _ref.value,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var containerRef = useRef(null); // Use the forwardedRef if provided, otherwise use our local ref

  var ref = forwardedRef || containerRef;
  var isEmptyText = value && (value === '<p><br></p>' || value === '<p></p>'); // Add a debug useEffect to check the content after initial render

  useEffect(function () {
    var currentElement = typeof ref === 'function' ? null : ref.current;
    if (!currentElement || !value || isEmptyText) return;
  }, [value, isEmptyText, ref]); // Initialize MathLive for all math expressions

  useEffect(function () {
    var currentElement = typeof ref === 'function' ? null : ref.current;
    if (!currentElement || !value || isEmptyText) return; // Helper function to render a math element

    var renderMathElement = function renderMathElement(element, latex) {
      if (!latex) {
        console.warn('Empty LaTeX content for element:', element);
        return;
      }

      try {
        var _element$parentNode;

        // Create a container div for the math element
        var container = document.createElement('div');
        container.className = 'math-container'; // Create a MathfieldElement

        var mfe = new MathfieldElement();
        mfe.value = latex; // Configure the MathfieldElement

        mfe.setAttribute('read-only', 'true');
        mfe.setAttribute('fonts-directory', 'https://unpkg.com/mathlive/dist/fonts');
        mfe.setAttribute('letter-shape-style', 'tex');
        mfe.setAttribute('font-size', '18px');
        mfe.setAttribute('math-mode-space', '1em');
        mfe.setAttribute('math-style', 'normal');
        mfe.setAttribute('min-font-scale', '0.8');
        mfe.setAttribute('smart-fence', 'true');
        mfe.setAttribute('smart-superscript', 'true');
        mfe.setAttribute('letter-spacing', '0.5px');
        container.appendChild(mfe); // Replace the original element with the container

        (_element$parentNode = element.parentNode) === null || _element$parentNode === void 0 ? void 0 : _element$parentNode.replaceChild(container, element);
      } catch (error) {
        console.error('Error rendering math element:', error, 'LaTeX:', latex);
      }
    }; // Process the different types of math elements


    var processLatexElements = function processLatexElements() {
      // Find all math nodes, checking multiple possible formats:
      // 1. <span data-type="math" data-latex="..."></span>
      var mathSpanElements = currentElement.querySelectorAll('span[data-type="math"]'); // 2. <math-inline latex="..."></math-inline>

      var mathInlineElements = currentElement.querySelectorAll('math-inline'); // 3. <span class="math-node" data-latex="..."></span>

      var mathNodeElements = currentElement.querySelectorAll('.math-node'); // 4. <span class="math" data-latex="..."></span>

      var mathClassElements = currentElement.querySelectorAll('.math'); // Process span math elements

      mathSpanElements.forEach(function (element) {
        var latex = element.getAttribute('data-latex') || '';

        if (latex) {
          renderMathElement(element, latex);
        }
      }); // Process math-inline elements

      mathInlineElements.forEach(function (element) {
        var latex = element.getAttribute('latex') || '';

        if (latex) {
          renderMathElement(element, latex);
        }
      }); // Process math-node elements

      mathNodeElements.forEach(function (element) {
        var latex = element.getAttribute('data-latex') || '';

        if (latex) {
          renderMathElement(element, latex);
        }
      }); // Process math class elements

      mathClassElements.forEach(function (element) {
        var latex = element.getAttribute('data-latex') || '';

        if (latex) {
          renderMathElement(element, latex);
        }
      });
    }; // Process after a short delay to ensure the HTML content is fully rendered


    setTimeout(function () {
      try {
        processLatexElements(); // Check if any math elements were processed

        var mathContainers = currentElement.querySelectorAll('.math-container');
      } catch (error) {
        console.error('Error processing LaTeX elements:', error);
      }
    }, 100);
    return function () {
      // Clean up any MathfieldElements when component unmounts
      if (currentElement) {
        var mathContainers = currentElement.querySelectorAll('.math-container');
        mathContainers.forEach(function (container) {
          while (container.firstChild) {
            container.removeChild(container.firstChild);
          }
        });
      }
    };
  }, [value, isEmptyText, ref]);

  if (!value || isEmptyText) {
    return null;
  }

  return /*#__PURE__*/_jsx(StyledDiv, _objectSpread({
    ref: ref,
    className: className,
    dangerouslySetInnerHTML: {
      __html: unescape(value)
    }
  }, rest));
});